"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_OPTIONS = {
    httpPorts: {
        api: 3000,
        ui: 5000
    },
    httpsPorts: {
        api: 3443,
        ui: 5443
    }
};
/**
 *
 * @param {*} providedOptions
 * @param {*} defaultOptions
 */
var mergeOptions = function (providedOptions, defaultOptions) {
    var merged = {
        httpPorts: {
            api: (providedOptions.httpPorts || defaultOptions.httpPorts).api,
            ui: (providedOptions.httpPorts || defaultOptions.httpPorts).ui
        },
        httpsPorts: {
            api: (providedOptions.httpsPorts || defaultOptions.httpsPorts).api,
            ui: (providedOptions.httpsPorts || defaultOptions.httpsPorts).ui
        }
    };
    return merged;
};
/**
 * Build the API url based on the current window location's protocol and the other values passed in.
 * @param {*} windowLocation This would be window.location when not testing, and a mocked object when testing.
 * @param {*} environment An environment subhost designator like "ci", "dev", "qa", "pprd" or "prod".
 * @param {*} apiHostname The base host name of the api server for the app. For example, the contests api host is "contests-api.biw.cloud". This will be used to build the url if the windowLocation does not have a specific port specified.
 * @param {*} devApiPort This param's value is used instead of the value in devUIPort if the devUIPort value is found. This is because when developing locally, the UI server and API server are running on different ports, and the API calls need to be made to the API port.
 * @param {*} devUIPort This param's value is replaced with devAPIPort if the devUIPort value is found. This is because when developing locally, the UI server and API server are running on different ports, and the API calls need to be made to the API port.
 */
var buildApiUrl = function (windowLocation, environment, apiHostname, devApiPort, devUIPort) {
    var urlParts = [
        windowLocation.protocol,
        '//',
        environment ? environment + '.' : '',
        windowLocation.port ? windowLocation.hostname : apiHostname,
        windowLocation.port ? ':' + windowLocation.port.replace(devUIPort, devApiPort) : ''
    ];
    return urlParts.join('');
};
/**
 * Determine what environment the webpage is in.
 * @param {*} windowLocation This would be window.location when not testing, and a mocked object when testing.
 */
var determineEnv = function (windowLocation) {
    var envs = ['dev', 'ci', 'qa', 'qa2', 'pprd'];
    var env = windowLocation.hostname.split('.').find(function (chunk) {
        return envs.indexOf(chunk) >= 0;
    });
    env = env && env.includes('qa') ? 'qa' : env;
    return env || '';
};
/**
 * Calculate the url to use for the node API.
 * @param {*} windowLocation This would be window.location when not testing, and a mocked object when testing.
 * @param {*} apiHostname The base host name of the api server for the app. For example, the contests api host is "contests-api.biw.cloud". This will be used to build the url if the windowLocation does not have a specific port specified.
 */
var getApiUrl = function (windowLocation, apiHostname, options) {
    if (options === void 0) { options = DEFAULT_OPTIONS; }
    var mergedOptions = mergeOptions(options, DEFAULT_OPTIONS);
    var env = determineEnv(windowLocation);
    var tls = windowLocation.protocol === 'https:';
    var devApiPort = tls ? mergedOptions.httpsPorts.api : mergedOptions.httpPorts.api;
    var devUIPort = tls ? mergedOptions.httpsPorts.ui : mergedOptions.httpPorts.ui;
    return buildApiUrl(windowLocation, env, apiHostname, devApiPort, devUIPort);
};
exports.default = getApiUrl;
//# sourceMappingURL=get-api-url.js.map